import React from 'react';
import { Shield, Award, Users, Clock, Target, Heart } from 'lucide-react';
import Logo from '../components/Logo.png';
import '../styles/Sobre.css';

const Sobre = () => {
  const stats = [
    { icon: Shield, number: '500+', label: 'Clientes Protegidos', ariaLabel: 'Mais de 500 clientes protegidos' },
    { icon: Award, number: '10+', label: 'Anos de Experiência', ariaLabel: 'Mais de 10 anos de experiência' },
    { icon: Users, number: '1500+', label: 'Profissionais Certificados', ariaLabel: 'Mais de 1500 profissionais certificados' },
    { icon: Clock, number: '24/7', label: 'Suporte Disponível', ariaLabel: 'Suporte disponível 24 horas por dia, 7 dias por semana' },
  ];

  const values = [
    {
      icon: Shield,
      title: 'Segurança',
      description: 'Priorizamos a segurança em todos os nossos serviços, garantindo a proteção de vidas e patrimónios.',
      ariaLabel: 'Valor de segurança',
    },
    {
      icon: Award,
      title: 'Excelência',
      description: 'Buscamos constantemente manter paradigmas de excelência nos serviços prestados.',
      ariaLabel: 'Valor de excelência',
    },
    {
      icon: Heart,
      title: 'Compromisso',
      description: 'Comprometemo-nos com a qualidade e eficiência em cada projeto que desenvolvemos.',
      ariaLabel: 'Valor de compromisso',
    },
  ];

  return (
    <div className="sobre-page">
      <section className="page-hero" aria-label="Sobre Fire Safety">
        <div className="container">
          <span className="section-subtitle">Sobre Nós</span>
          <h1 className="section-title">Fire Safety Lda</h1>
          <p className="section-description">A sua segurança no lugar certo. Especialistas em proteção contra incêndios, higiene e segurança no trabalho com mais de 10 anos de experiência em Moçambique.</p>
        </div>
      </section>

      {/* Stats Section */}
      <section className="stats-section">
        <div className="container">
          <div className="stats-grid">
            {stats.map((stat, index) => {
              const IconComponent = stat.icon;
              return (
                <div key={index} className="stat-card">
                  <div className="stat-icon" aria-label={stat.ariaLabel}>
                    <IconComponent size={32} />
                  </div>
                  <h3 className="stat-number">{stat.number}</h3>
                  <p className="stat-label">{stat.label}</p>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* Company Info Section */}
      <section className="company-info-section">
        <div className="container">
          <div className="company-info-grid">
            <div className="company-info-text">
              <span className="section-subtitle">Quem Somos</span>
              <h2 className="section-title">Empresa Nacional Certificada</h2>
              <p className="section-description">
                A Fire Safety Lda. é uma empresa nacional, registada pelo registo de entidades legais sob nº100565269 e é titular do NUIT nº 400594368, constituída por uma equipe técnica qualificada de especialistas nas áreas de Higiene e Segurança no Trabalho, Meio Ambiente e Qualidade.
              </p>
              <p className="section-description">
                Contamos com bombeiros profissionais no activo e na reforma com conhecimento sólido e larga experiência na protecção contra incêndios, especialistas na avaliação cuidadosa, identificação e análise de riscos de incêndio.
              </p>
            </div>
            <div className="company-info-image">
              <img
                src={Logo}
                alt="Equipe Fire Safety"
                loading="lazy"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Mission Vision Values */}
      <section className="values-section">
        <div className="container">
          <div className="values-header">
            <span className="section-subtitle">Nossos Valores</span>
            <h2 className="section-title">O Que Nos Move</h2>
          </div>

          <div className="values-grid">
            {values.map((value, index) => {
              const IconComponent = value.icon;
              return (
                <div key={index} className="value-card">
                  <div className="value-icon" aria-label={value.ariaLabel}>
                    <IconComponent size={32} />
                  </div>
                  <h3 className="value-title">{value.title}</h3>
                  <p className="value-description">{value.description}</p>
                </div>
              );
            })}
          </div>

          <div className="mission-card">
            <div className="mission-icon" aria-label="Nossa missão">
              <Target size={32} />
            </div>
            <h3 className="mission-title">Nossa Missão</h3>
            <p className="mission-description">
              A segurança dos trabalhadores e a protecção do património das empresas e instituições contra incêndios, analisando previamente as peculiaridades e graus de risco, e buscando constantemente manter paradigmas de excelência nos serviços prestados de acordo com as características específicas de cada cliente.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Sobre;